import { withStyles } from '@material-ui/core/styles';
import { TableSortLabel } from '@material-ui/core';

export default withStyles({
  icon: {
    opacity: 0.2
  }
})(TableSortLabel);
